import { useQuery } from "@tanstack/react-query";

import { FETCH_ERROR } from "../consts/fetch-error";
import { getRole, getRoles } from "../services/role";
import { useLocale } from "../stores/locale";

export function useGetRoles() {
  const { currentLanguage } = useLocale();

  return useQuery({
    queryKey: ["roles", currentLanguage],
    queryFn: () => getRoles(currentLanguage),
    staleTime: 1000 * 60 * 5,
    retry: (_failureCount, error: unknown) =>
      error !== FETCH_ERROR.UNAUTHORIZED,
  });
}

export function useGetRole(id: string) {
  const { currentLanguage } = useLocale();

  return useQuery({
    queryKey: ["role", id, currentLanguage],
    queryFn: () => getRole(id, currentLanguage),
    retry: (_failureCount, error: unknown) =>
      error !== FETCH_ERROR.UNAUTHORIZED,
  });
}
